
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61575119263782";
const INSTAGRAM_URL = "https://www.instagram.com/official.autocare/";
const LINKEDIN_URL = "https://www.linkedin.com/company/107369987/";

const Footer = () => {
  return (
    <footer className="bg-white py-12 px-4">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-autocare-blue font-poppins font-bold text-2xl">أوتو<span className="text-autocare-yellow">كير</span></span>
            </div>
            <p className="text-gray-600 mb-4">شريكك الموثوق لتغيير زيت سيارتك في فلسطين.</p>
            {/* Social Media Icons under the description */}
            <div className="flex items-center space-x-4 mt-2">
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-500 hover:text-autocare-blue transition-colors">
                <Facebook size={22} />
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-500 hover:text-autocare-yellow transition-colors">
                <Instagram size={22} />
              </a>
              <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-500 hover:text-[#0077B5] transition-colors">
                <Linkedin size={22} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-4">روابط سريعة</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-600 hover:text-autocare-blue transition-colors">الرئيسية</Link></li>
              <li><Link to="/oil-finder" className="text-gray-600 hover:text-autocare-blue transition-colors">البحث عن الزيت</Link></li>
              <li><Link to="/oil-request" className="text-gray-600 hover:text-autocare-blue transition-colors">أطلب زيت سيارتك</Link></li>
              <li><Link to="/booking" className="text-gray-600 hover:text-autocare-blue transition-colors">احجز موعدك</Link></li>
              <li><Link to="/shops" className="text-gray-600 hover:text-autocare-blue transition-colors">المحلات</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-4">صفحات أخرى</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-600 hover:text-autocare-blue transition-colors">من نحن</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-autocare-blue transition-colors">تواصل معنا</Link></li>
              <li><Link to="/terms" className="text-gray-600 hover:text-autocare-blue transition-colors">الشروط والأحكام</Link></li>
              <li><Link to="/support" className="text-gray-600 hover:text-autocare-blue transition-colors">الدعم الفني</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-4">تواصل معنا</h4>
            <ul className="space-y-2">
              <li className="text-gray-600">نابلس، فلسطين</li>
              <li>
                <a href="mailto:autocarepalestine@gmail.com" className="text-gray-600 hover:text-autocare-blue transition-colors">
                  autocarepalestine@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:0566752075" className="text-gray-600 hover:text-autocare-blue transition-colors">
                  0566752075
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">© {new Date().getFullYear()} أوتو كير. جميع الحقوق محفوظة.</p>
          <div className="mt-4 md:mt-0 flex items-center space-x-4">
            <Link to="/terms" className="text-gray-600 hover:text-autocare-blue transition-colors">الشروط</Link>
            <Link to="/privacy" className="text-gray-600 hover:text-autocare-blue transition-colors">الخصوصية</Link>
            <Link to="/support" className="text-gray-600 hover:text-autocare-blue transition-colors">الدعم</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
